<div class="w-full flex justify-center">
  @let qty = quantity();
  @if (qty === 0) {
    <button
      appButton
      variant="default"
      class="w-full"
      (click)="onIncrease()"
      [disabled]="product().Existen === 0"
    >
      <mat-icon aria-hidden="true" class="mr-2 !text-lg !w-[18px] !h-[18px]"
        >shopping_cart</mat-icon
      >
      Agregar al carrito
    </button>
  } @else {
    <div
      class="flex items-center justify-between w-full bg-gray-100 rounded-md p-1 gap-1"
    >
      <button
        appButton
        variant="ghost"
        size="icon"
        class="!w-8 !h-8 hover:!bg-red-100 hover:!text-red-700 disabled:opacity-40"
        (click)="onDecrease()"
        [disabled]="qty <= 0"
        aria-label="Disminuir cantidad"
      >
        <mat-icon aria-hidden="true" class="!text-lg">remove</mat-icon>
      </button>

      <div class="flex flex-1 items-center justify-center h-8">
        <input
          #qtyInput
          type="number"
          class="w-12 h-7 bg-white border border-transparent rounded text-center font-bold text-primary focus:outline-none focus:ring-2 focus:ring-primary/20 hover:bg-gray-50 focus:border-primary transition-all text-[15px] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          [value]="qty"
          (change)="updateQuantity(qtyInput.value)"
          (keyup.enter)="updateQuantity(qtyInput.value)"
          min="0"
          [max]="product().Existen"
          aria-label="Cantidad"
        />
      </div>

      <button
        appButton
        variant="ghost"
        size="icon"
        class="!w-8 !h-8 hover:!bg-primary/10 hover:!text-primary disabled:opacity-40"
        (click)="onIncrease()"
        [disabled]="product().Existen === 0 || qty >= product().Existen"
        aria-label="Aumentar cantidad"
      >
        <mat-icon aria-hidden="true" class="!text-lg">add</mat-icon>
      </button>
    </div>
  }
</div>
